import React from "react";
import {
  CHANGE_BO_TYPE,
  CHANGE_FREQUENCY,
} from "../../../../actions/create-bot-type";
import BooleanView from "../BooleanView";
import SliderView from "../SliderView";
import TutorialPopup from "../../../help/TutorialPopup";
import { useDispatch, useSelector } from "react-redux";
import { Frequencies, FrequencyValues,FrequencyValuesSimple,FrequenciesSimple,BotType, SUB_TIER, FrequencyValuesPro, FrequenciesPro } from "../../../../Const";
import { checkSub, isMaster, isPro } from "../../../../utils/SubUtils";
import { Form, InputGroup } from "react-bootstrap";
import { formatNumberToString, getFreq, getFreqVal } from "../../../../utils/Utils";

const SellBotParamsView = (props) => {
  const { newBot ,t} = props;
  const orderType = newBot.baseOrderType;
  const frequency = newBot.frequency;
  const fund = newBot.initFund;
  
  const dispatch = useDispatch();
  const subscription = useSelector(
    (state) => state.auth.user.user_subscription
  );
  const { subPremium, subTier } = checkSub(subscription);
  const tradingFreqValues = getFreqVal(newBot,subscription)
  const tradingFreqencies = getFreq(newBot,subscription)
  
  const orderTypeChanged = (val) => {
    dispatch({
      type: CHANGE_BO_TYPE,
      payload: val,
    });
  };

  const frequencyChanged = (val) => {
    dispatch({
      type: CHANGE_FREQUENCY,
      payload: val,
    });
  };
  const formartFrequency = (value) => tradingFreqencies[value];
  return (
    <div>
      <div style={{ marginTop: 20 }}>
        <SliderView
          title={t("tf")}
          max={tradingFreqValues.length - 1}
          value={tradingFreqValues.indexOf(frequency)}
          formatLabel={formartFrequency}
          onChange={(value) => frequencyChanged(tradingFreqValues[value])}
          tutorial={<TutorialPopup content={t("trading-freq-help")}  />}
        />
      </div>
    </div>
  );
};

export default SellBotParamsView;
